import axios from 'axios';
const qs = require('qs');
const { Utils } = require('@/assets/js/scripts/utils/Utils.js');

import { EventBus } from '@/components/EventBus.js';

export class RequestsUtils {

	//static

    static get(url, params, successFn, failFn, showMessageSuccess, loading, responseType) {
      if(typeof loading === 'undefined' || loading === true) {
			EventBus.$emit('open_loader');
		}

		let configs = {
			params: params
		};

		if(!Utils.isNullOrUndefined(responseType)) {
			configs.responseType = responseType;
		}

      axios.get(url, configs)
		.then(response => {
			RequestsUtils.onSuccess(response, successFn, loading, showMessageSuccess);
		}).catch(error => {
			RequestsUtils.onFail(error, failFn, loading);
        });
    }

	static post(url, params, successFn, failFn, showMessageSuccess, loading, responseType, contentType) {
		
		if(typeof loading === 'undefined' || loading === true) {
			EventBus.$emit('open_loader');
		}

		let contentTypeToUse = "application/x-www-form-urlencoded";

		if(!Utils.isNullOrUndefined(contentType)) {
			contentTypeToUse = contentType;
		}

		let data = qs.stringify(params);

		//If it is a MULTIPART, data needs to ebe passed 'as is'
		if (contentTypeToUse == "multipart/form-data") {
			data = params;
		}

		if(contentTypeToUse == "text/json" || contentTypeToUse == "application/json") {
			data = JSON.stringify(params);
		}

		let configs = {
			method: 'POST',
			url: url,
			data: data,
			headers: {
				'Content-Type': contentTypeToUse
			}
		}

		if(responseType != null) {
			configs.responseType = responseType;
		}

		axios(configs)
		.then(response => {
			RequestsUtils.onSuccess(response, successFn, loading, showMessageSuccess);
		})
		.catch(error => {
			RequestsUtils.onFail(error, failFn, loading);
		});
	}

	static onSuccess(response, successFn, loading, showMessageSuccess) {
		if(typeof loading === 'undefined' || loading === true) {
			// Close loader
			EventBus.$emit('close_loader');
		}

		if(typeof successFn === 'function') {
			successFn(response);
		}

		if(typeof showMessageSuccess === 'undefined' || showMessageSuccess === true) {
			// Recupera eventuale messaggio di errore dalla response
			EventBus.$emit('open_dialog_success', {
				message: 'Operazione conclusa con successo'
			});
		}
	}

	static onFail(error, failFn, loading) {
		if(typeof loading === 'undefined' || loading === true) {
			EventBus.$emit('close_loader');
		}

		if(typeof failFn === 'function') {
			failFn(error);
		}

		// Recupera eventuale messaggio di errore dalla response
		let message = "";
		if(!Utils.isNullOrUndefined(error) && !Utils.isNullOrUndefined(error.response.data.msg)) {
			message = error.response.data.msg;

			EventBus.$emit('open_dialog_error', {
				message: "Non è stato possibile completare l'operazione richiesta. <br>" + message
			});

			return;
		}

		// Recupera eventuale messaggio di errore di sistema
		if(!Utils.isNullOrUndefined(error.message)) {
			// Se errore di sistema printa l'errore solo in console
			console.log(error.message);
		}
	}

}